import parseValue from "./parse-value";

const paddingPattern = /^{([-+]?\d+,){3}[-+]?\d+}$/;

/**
 * Utility method to generate padding styles based on the field padding property.
 *
 * Padding is expected to be in the format "{top,left,bottom,right}" where each comma separated value
 * is an integer number of pixels.
 *
 * Note that this order is not consistent with the way CSS orders padding/margins, which is {top,right,bottom,left}.
 * This is because padding was originally used for mobile clients which expect them in this order.
 */
const calculatePadding = field => {
  const { padding } = field;

  if (!padding || !paddingPattern.test(padding)) {
    return null;
  }

  const [top, left, bottom, right] = parseValue(padding);
  return {
    padding: `${top}px ${right}px ${bottom}px ${left}px`
  };
};

export default calculatePadding;
